import React, { useState, useEffect } from "react";

import { Alert, Table, Button, Container, Modal, Form, Pagination, Spinner } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import UserService from "../services/user.service";

const AdManager = () => {
  const [ads, setAds] = useState([]);
  const [formData, setFormData] = useState({
    company_name: '',
    company_mobile_number: '',
    company_email: '',
    contact_first_name: '',
    contact_last_name: '',
    contact_mobile_number: '',
    contact_email: '',
    rec_date: '',
    street: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    bank_name: "",
    bank_account_number: "",
    bank_swift_code: "",
    bank_iban: "",
    bank_address: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('company_name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    loadAds();
  }, [currentPage, searchTerm, sortField, sortOrder, refresh]);

  const loadAds = async () => {
    setApiErrors('');
    setLoading(true);
    try {
      const response = await UserService.getAllAds({
        page: currentPage,
        search: searchTerm,
        sort: sortField,
        order: sortOrder
      });
      setAds(response.data.ads);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      setApiErrors('Fehler beim Laden des Vertriebspartners.');
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to the first page when searching
  };

  const handleSortChange = (field) => {
    const newSortOrder = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(newSortOrder);
  };

  const handleCreateClick = () => {
    setFormData({
      company_name: '',
      company_mobile_number: '',
      company_email: '',
      contact_first_name: '',
      contact_last_name: '',
      contact_mobile_number: '',
      contact_email: '',
      rec_date: '',
      street: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    bank_name: "",
    bank_account_number: "",
    bank_swift_code: "",
    bank_iban: "",
    bank_address: "",
    });
    setApiErrors('');
    setErrors({});
    setShowCreateModal(true);
  };

  const handleEditClick = (ad) => {
    setSelectedAd(ad);
    setFormData(ad);
    setApiErrors('');
    setErrors({});
    setShowEditModal(true);
  };

  const handleDeleteClick = async (adm_id) => {
    if (window.confirm('Sind Sie sicher, dass Sie diesen Datensatz löschen möchten?')) {
      try {
        await UserService.deleteAd(adm_id);
        setRefresh(prev => !prev); // Löst das Neuladen aus
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          setApiErrors(error.response.data.message); // Use backend error message
        } else {
          setApiErrors('Fehler beim Löschen des Datensatzes.'); // Fallback message
        }
      }
    }
  };

  

  const validateForm = () => {
    const newErrors = {};
  
    if (formData.company_name && formData.company_name.trim().length < 3) {
      newErrors.company_name = 'Der Firmenname muss mindestens 3 Zeichen lang sein.';
    }
    
    if (!formData.company_email) {
      newErrors.company_email = '	Firmen-E-Mail ist ein Pflichtfeld.';
    } else if (!/\S+@\S+\.\S+/.test(formData.company_email)) {
      newErrors.company_email = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
    }
    
    if (!formData.contact_first_name) {
      newErrors.contact_first_name = 'Vorname des Ansprechpartners ist ein Pflichtfeld.';
    }
    
    if (!formData.contact_last_name) {
      newErrors.contact_last_name = 'Nachname des Ansprechpartners ist ein Pflichtfeld.';
    }
    
    // Firmen-Mobilnummer validation (optional field)
    if (formData.company_mobile_number && !/^(00\d{2,3}|0\d{4,}|(\+49)?\d{3,})\d{6,}$/g.test(formData.company_mobile_number)) {
      newErrors.company_mobile_number = 'Bitte geben Sie eine gültige Mobilfunknummer ein';
    }
    
  
  // Contact mobile number validation (optional field)
  if (formData.contact_mobile_number && !/^(00\d{2,3}|0\d{4,}|(\+49)?\d{3,})\d{6,}$/g.test(formData.contact_mobile_number)) {
    newErrors.contact_mobile_number = 'Bitte geben Sie eine gültige Mobilfunknummer ein.';
  }
    
    if (!formData.rec_date) {
      newErrors.rec_date = 'Erstellungsdatum ist ein Pflichtfeld.';
    }
  
      // Address fields
    if (formData.street && !formData.street.trim()) {
      newErrors.street = 'Straße ist erforderlich, wenn sie angegeben ist.';
  }
  if (formData.city && !formData.city.trim()) {
      newErrors.city = 'Stadt ist erforderlich, wenn sie angegeben ist';
  }
  if (formData.state && !formData.state.trim()) {
      newErrors.state = 'Bundesland ist erforderlich, wenn es angegeben ist';
  }
  if (formData.postal_code && !/^\d{4,10}$/.test(formData.postal_code)) {
      newErrors.postal_code = 'Postleitzahl muss eine gültige Zahl zwischen 4 und 10 Ziffern sein';
  }
  if (formData.country && !formData.country.trim()) {
      newErrors.country = 'Land ist erforderlich, wenn es angegeben ist';
  }

  // Bank fields
  if (formData.bank_name && !formData.bank_name.trim()) {
      newErrors.bank_name = 'Bankname ist erforderlich, wenn es angegeben ist';
  }
  if (formData.bank_account_number && !/^\d{8,20}$/.test(formData.bank_account_number)) {
      newErrors.bank_account_number = 'Bankkontonummer muss zwischen 8 und 20 Ziffern lang sein';
  }
  if (formData.bank_swift_code && !/^[A-Z0-9]{8,11}$/.test(formData.bank_swift_code)) {
      newErrors.bank_swift_code = 'SWIFT Code muss zwischen 8 und 11 alphanumerischen Zeichen liegen';
  }
  if (formData.bank_iban && !/^[A-Z0-9]{15,34}$/.test(formData.bank_iban)) {
      newErrors.bank_iban = 'IBAN muss zwischen 15 und 34 alphanumerischen Zeichen liegen';
  }
  if (formData.bank_address && !formData.bank_address.trim()) {
      newErrors.bank_address = 'Bankadresse ist erforderlich, wenn sie angegeben ist';
  }

    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  
  
  
  
  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validateForm();
  };
  
  

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setApiErrors('');
    setErrors({});
    if (!validateForm()) {
      setLoading(false);
      setApiErrors('Bitte korrigieren Sie die Fehler im Formular.');
      return;
    }

    try {
      await UserService.createAd(formData);
      setShowCreateModal(false);
      setRefresh(prev => !prev); // Löst das Neuladen aus
    } catch (error) {
      setApiErrors('Fehler beim Erstellen des Datensatzes.');
    } finally {
      setLoading(false);
    }
  };

  const handleBlur = () => {
    validateForm();
 };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setApiErrors('');
    setErrors({});

    if (!validateForm()) {
      setLoading(false);
      setApiErrors('Please correct the errors in the form.');
      return;
    }

    try {
      await UserService.updateAd(selectedAd.adm_id, formData);
      setShowEditModal(false);
      setRefresh(prev => !prev); // Löst das Neuladen aus
    } catch (error) {
      setApiErrors('Fehler beim Aktualisieren des Datensatzes.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <h1>Vertriebspartnerverwaltung</h1>
      {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
      <Button onClick={handleCreateClick}>Vertriebsparter anlegen</Button>
      <Form.Group controlId="searchAd">
        <Form.Label>Vertriebspartner suche</Form.Label>
        <Form.Control
          type="text"
          placeholder="Suche nach Firmenname..."
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </Form.Group>
      {loading && <Spinner animation="border" />}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th onClick={() => handleSortChange('adm_id')}>ID</th>
            <th onClick={() => handleSortChange('company_name')}>Firmenname</th>
            <th onClick={() => handleSortChange('company_email')}>E-Mail</th>
            <th>Ansprechpartner</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {ads.map(ad => (
            <tr key={ad.adm_id}>
              <td>{ad.adm_id}</td>
              <td>{ad.company_name}</td>
              <td>{ad.company_email}</td>
              <td>{`${ad.contact_first_name} ${ad.contact_last_name}`}</td>
              <td>
                <Button variant="warning" onClick={() => handleEditClick(ad)} title="Bearbeiten" aria-label="Bearbeiten"><FaEdit /></Button>{' '}
                <Button variant="danger" onClick={() => handleDeleteClick(ad.adm_id)} title="Löschen" aria-label="Löschen"><FaTrash /></Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination>
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item key={index} active={index + 1 === currentPage} onClick={() => setCurrentPage(index + 1)}>
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      {/* Create Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Vertriebspartner anlegen</Modal.Title>
        </Modal.Header>
        {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
        <Modal.Body>
          <Form onSubmit={handleCreateSubmit}>
            <Form.Group controlId="company_name">
              <Form.Label>Firmenname</Form.Label>
              <Form.Control
                type="text"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.company_name}
               
              />
              <Form.Control.Feedback type="invalid">{errors.company_name}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="company_mobile_number">
              <Form.Label>Firmen-Mobilnummer</Form.Label>
              <Form.Control
                type="text"
                name="company_mobile_number"
                value={formData.company_mobile_number}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.company_mobile_number}
              />
              <Form.Control.Feedback type="invalid">{errors.company_mobile_number}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="company_email">
              <Form.Label>Firmen-E-Mail(Benutzername)</Form.Label>
              <Form.Control
                type="email"
                name="company_email"
                value={formData.company_email}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.company_email}
                required
              />
              <Form.Control.Feedback type="invalid">{errors.company_email}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="contact_first_name">
              <Form.Label>Vorname (Ansprechpartner)</Form.Label>
              <Form.Control
                type="text"
                name="contact_first_name"
                value={formData.contact_first_name}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.contact_first_name}
                required
              />
              <Form.Control.Feedback type="invalid">{errors.contact_first_name}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="contact_last_name">
              <Form.Label>Nachname(Ansprechpartner)</Form.Label>
              <Form.Control
                type="text"
                name="contact_last_name"
                value={formData.contact_last_name}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.contact_last_name}
                required
              />
              <Form.Control.Feedback type="invalid">{errors.contact_last_name}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="contact_mobile_number">
              <Form.Label>Kontakt-Mobilnr.(Ansprechpartner)</Form.Label>
              <Form.Control
                type="text"
                name="contact_mobile_number"
                value={formData.contact_mobile_number}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.contact_mobile_number}
              />
              <Form.Control.Feedback type="invalid">{errors.contact_mobile_number}</Form.Control.Feedback>
     
            </Form.Group>

            <Form.Group controlId="contact_email">
              <Form.Label>Kontakt-E-Mail(Ansprechpartner)</Form.Label>
              <Form.Control
                type="email"
                name="contact_email"
                value={formData.contact_email}
                onChange={handleChange}
                onBlur={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="rec_date">
              <Form.Label>Registrierungsdatum</Form.Label>
              <Form.Control
                type="date"
                name="rec_date"
                value={formData.rec_date}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.rec_date} // Show validation error if exists
                required
              />
              <Form.Control.Feedback type="invalid">{errors.rec_date}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formStreet">
  <Form.Label>Straße</Form.Label>
  <Form.Control
    type="text"
    placeholder="Straße eingeben"
    name="street"
    value={formData.street}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.street}
  />
  <Form.Control.Feedback type="invalid">
    {errors.street}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formCity">
  <Form.Label>Stadt</Form.Label>
  <Form.Control
    type="text"
    placeholder="Stadt eingeben"
    name="city"
    value={formData.city}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.city}
  />
  <Form.Control.Feedback type="invalid">
    {errors.city}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formState">
  <Form.Label>Bundesland</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bundesland eingeben"
    name="state"
    value={formData.state}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.state}
  />
  <Form.Control.Feedback type="invalid">
    {errors.state}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formPostalCode">
  <Form.Label>PLZ</Form.Label>
  <Form.Control
    type="text"
    placeholder="PLZ eingeben"
    name="postal_code"
    value={formData.postal_code}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.postal_code}
  />
  <Form.Control.Feedback type="invalid">
    {errors.postal_code}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formCountry">
  <Form.Label>Land</Form.Label>
  <Form.Control
    type="text"
    placeholder="Land eingeben"
    name="country"
    value={formData.country}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.country}
  />
  <Form.Control.Feedback type="invalid">
    {errors.country}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankName">
  <Form.Label>Bankname</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bankname eingeben"
    name="bank_name"
    value={formData.bank_name}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_name}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_name}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankAccountNumber">
  <Form.Label>Kontonummer</Form.Label>
  <Form.Control
    type="text"
    placeholder="Kontonummer eingeben"
    name="bank_account_number"
    value={formData.bank_account_number}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_account_number}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_account_number}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankSwiftCode">
  <Form.Label>SWIFT-Code</Form.Label>
  <Form.Control
    type="text"
    placeholder="SWIFT-Code eingeben"
    name="bank_swift_code"
    value={formData.bank_swift_code}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_swift_code}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_swift_code}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankIBAN">
  <Form.Label>IBAN</Form.Label>
  <Form.Control
    type="text"
    placeholder="IBAN eingeben"
    name="bank_iban"
    value={formData.bank_iban}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_iban}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_iban}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankAddress">
  <Form.Label>Bankadresse</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bankadresse eingeben"
    name="bank_address"
    value={formData.bank_address}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_address}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_address}
  </Form.Control.Feedback>
</Form.Group>

            <Button style={{ marginTop: '20px' }} variant="primary" type="submit">Erstellen</Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Vertriebspartner bearbeiten</Modal.Title>
        </Modal.Header>
        {apiErrors && <Alert variant="danger">{apiErrors}</Alert>}
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
            <Form.Group controlId="company_name">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                type="text"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.company_name}
                required
              />
              <Form.Control.Feedback type="invalid">{errors.company_name}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="company_mobile_number">
              <Form.Label>Firmen-Mobilnummer</Form.Label>
              <Form.Control
                type="text"
                name="company_mobile_number"
                value={formData.company_mobile_number}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.company_mobile_number}
              />
              <Form.Control.Feedback type="invalid">{errors.company_mobile_number}</Form.Control.Feedback>
     
            </Form.Group>

            <Form.Group controlId="company_email">
              <Form.Label>Firmen-E-Mail</Form.Label>
              <Form.Control
                type="email"
                name="company_email"
                value={formData.company_email}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.company_email}
                required
              />
              <Form.Control.Feedback type="invalid">{errors.company_email}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="contact_first_name">
              <Form.Label>Contact First Name</Form.Label>
              <Form.Control
                type="text"
                name="contact_first_name"
                value={formData.contact_first_name}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.contact_first_name}
                required
              />
              <Form.Control.Feedback type="invalid">{errors.contact_first_name}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="contact_last_name">
              <Form.Label>Contact Last Name</Form.Label>
              <Form.Control
                type="text"
                name="contact_last_name"
                value={formData.contact_last_name}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.contact_last_name}
                required
              />
              <Form.Control.Feedback type="invalid">{errors.contact_last_name}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="contact_mobile_number">
              <Form.Label>Contact Mobile Number</Form.Label>
              <Form.Control
                type="text"
                name="contact_mobile_number"
                value={formData.contact_mobile_number}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.contact_mobile_number}
              />
              <Form.Control.Feedback type="invalid">{errors.contact_mobile_number}</Form.Control.Feedback>
     
            </Form.Group>

            <Form.Group controlId="contact_email">
              <Form.Label>Contact Email</Form.Label>
              <Form.Control
                type="email"
                name="contact_email"
                value={formData.contact_email}
                onChange={handleChange}
                onBlur={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="rec_date">
              <Form.Label>Record Date</Form.Label>
              <Form.Control
                type="date"
                name="rec_date"
                value={formData.rec_date}
                onChange={handleChange}
                onBlur={handleChange}
                isInvalid={!!errors.rec_date} // Show validation error if exists
                required
              />
              <Form.Control.Feedback type="invalid">{errors.rec_date}</Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formStreet">
  <Form.Label>Street</Form.Label>
  <Form.Control
    type="text"
    placeholder="Straße eingeben"
    name="street"
    value={formData.street}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.street}
  />
  <Form.Control.Feedback type="invalid">
    {errors.street}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formCity">
  <Form.Label>City</Form.Label>
  <Form.Control
    type="text"
    placeholder="Stadt eingeben"
    name="city"
    value={formData.city}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.city}
  />
  <Form.Control.Feedback type="invalid">
    {errors.city}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formState">
  <Form.Label>State</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bundesland eingeben"
    name="state"
    value={formData.state}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.state}
  />
  <Form.Control.Feedback type="invalid">
    {errors.state}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formPostalCode">
  <Form.Label>Postal Code</Form.Label>
  <Form.Control
    type="text"
    placeholder="PLZ eingeben"
    name="postal_code"
    value={formData.postal_code}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.postal_code}
  />
  <Form.Control.Feedback type="invalid">
    {errors.postal_code}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formCountry">
  <Form.Label>Country</Form.Label>
  <Form.Control
    type="text"
    placeholder="Land eingeben"
    name="country"
    value={formData.country}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.country}
  />
  <Form.Control.Feedback type="invalid">
    {errors.country}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankName">
  <Form.Label>Bank Name</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bankname eingeben"
    name="bank_name"
    value={formData.bank_name}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_name}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_name}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankAccountNumber">
  <Form.Label>Bank Account Number</Form.Label>
  <Form.Control
    type="text"
    placeholder="Kontonummer eingeben"
    name="bank_account_number"
    value={formData.bank_account_number}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_account_number}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_account_number}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankSwiftCode">
  <Form.Label>SWIFT Code</Form.Label>
  <Form.Control
    type="text"
    placeholder="SWIFT-Code eingeben"
    name="bank_swift_code"
    value={formData.bank_swift_code}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_swift_code}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_swift_code}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankIBAN">
  <Form.Label>IBAN</Form.Label>
  <Form.Control
    type="text"
    placeholder="IBAN eingeben"
    name="bank_iban"
    value={formData.bank_iban}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_iban}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_iban}
  </Form.Control.Feedback>
</Form.Group>

<Form.Group controlId="formBankAddress">
  <Form.Label>Bank Address</Form.Label>
  <Form.Control
    type="text"
    placeholder="Bankadresse eingeben"
    name="bank_address"
    value={formData.bank_address}
    onChange={handleChange}
    onBlur={handleBlur}
    isInvalid={!!errors.bank_address}
  />
  <Form.Control.Feedback type="invalid">
    {errors.bank_address}
  </Form.Control.Feedback>
</Form.Group>

            <Button style={{ marginTop: '20px' }} variant="primary" type="submit">Aktualisieren</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default AdManager;
